import { EMPTY_LIST } from '../../../../constants/common'
import { getUserFullName } from '../../../../utils/user'
import { BirdviewChartMetric } from '../../DashboardBirdview.constants.controls'
import {
  checkIsBirdviewAvgTimeMetric,
  toBirdviewChartSection,
  toBirdviewMetricChartSection,
} from '../../DashboardBirdview.utils.charts'

import {
  BIRDVIEW_CHART_NO_CATEGORY_ITEM,
  BIRDVIEW_CHART_OTHER_BUILDINGS_ITEM,
  BIRDVIEW_CHART_OTHER_CATEGORIES_ITEM,
  BIRDVIEW_CHART_OTHER_ITEM,
  BIRDVIEW_CHART_UNASSIGNED_ITEM,
} from './useBirdviewAnalyticsLoaders.constants'

function getBirdviewBuildingMetricValue({ metric, row }) {
  switch (metric) {
    case BirdviewChartMetric.AvgTime:
      return row.avg_days
    case BirdviewChartMetric.PerUnits:
      return row.per_100_units
    default:
      return row.count
  }
}

function toBirdviewBuildingItem({ metric, row }) {
  return {
    id: row.id,
    label: row.title,
    value: getBirdviewBuildingMetricValue({ metric, row }),
  }
}

function toBirdviewCategoryItem(row) {
  return row.id === null
    ? { ...BIRDVIEW_CHART_NO_CATEGORY_ITEM, value: row.count }
    : { id: row.id, label: row.name, value: row.count }
}

function checkIsBirdviewNoCategoryItem(item) {
  return item.id === BIRDVIEW_CHART_NO_CATEGORY_ITEM.id
}

// The API counts a late request in both `open` and `overdue`.
function toBirdviewManagerBar({ metric, row }) {
  return checkIsBirdviewAvgTimeMetric(metric)
    ? { value: row.avg_days }
    : {
        closed: row.count - row.open,
        open: row.open - row.overdue,
        overdue: row.overdue,
        value: row.count,
      }
}

function toBirdviewManagerItem({ metric, row }) {
  return {
    ...toBirdviewManagerBar({ metric, row }),
    id: row.id,
    label: getUserFullName(row),
  }
}

export function toBirdviewBuildingSection(data) {
  return toBirdviewMetricChartSection({
    items: [
      ...data.items.map(row =>
        toBirdviewBuildingItem({ metric: data.metric, row })
      ),
      ...(data.other
        ? [
            {
              ...BIRDVIEW_CHART_OTHER_BUILDINGS_ITEM,
              value: getBirdviewBuildingMetricValue({
                metric: data.metric,
                row: data.other,
              }),
            },
          ]
        : EMPTY_LIST),
    ],
    metric: data.metric,
  })
}

export function toBirdviewCategorySection(data) {
  const items = data.items.map(toBirdviewCategoryItem)

  return toBirdviewChartSection([
    ...items.filter(item => !checkIsBirdviewNoCategoryItem(item)),
    { ...BIRDVIEW_CHART_OTHER_CATEGORIES_ITEM, value: data.other },
    ...items.filter(checkIsBirdviewNoCategoryItem),
  ])
}

// A request with several managers counts for each, so the total is the API's.
export function toBirdviewManagerSection(data) {
  return {
    ...toBirdviewMetricChartSection({
      items: [
        ...data.items.map(row =>
          toBirdviewManagerItem({ metric: data.metric, row })
        ),
        ...(data.other
          ? [
              {
                ...BIRDVIEW_CHART_OTHER_ITEM,
                ...toBirdviewManagerBar({
                  metric: data.metric,
                  row: data.other,
                }),
              },
            ]
          : EMPTY_LIST),
        ...(data.unassigned
          ? [
              {
                ...BIRDVIEW_CHART_UNASSIGNED_ITEM,
                ...toBirdviewManagerBar({
                  metric: data.metric,
                  row: data.unassigned,
                }),
              },
            ]
          : EMPTY_LIST),
      ],
      metric: data.metric,
    }),
    total: data.open_total,
  }
}
